import { Award, Trophy, Star } from 'lucide-react'

export const certifications = [
  {
    title: "Microsoft Azure Data Scientist Associate",
    issuer: "Microsoft",
    date: "2024",
    icon: Award,
    verified: true
  },
  {
    title: "AWS Academy Cloud Foundations",
    issuer: "Amazon Web Services",
    date: "2024",
    icon: Award,
    verified: true
  },
  {
    title: "HackMol 4.0 Finalist",
    issuer: "NIT Jalandhar",
    date: "2023",
    icon: Trophy,
    verified: true
  },
  {
    title: "Machine Learning A-Z",
    issuer: "Udemy",
    date: "2022",
    icon: Award,
    verified: true
  }
]

export const detailedCertifications = [
  {
    title: "Microsoft Certified: Azure Data Scientist Associate",
    date: "March 2025 - March 2026",
    id: "42DF39354B276076",
    link: "https://learn.microsoft.com/api/credentials/share/en-in/vishalpanwar/42DF39354B276076?sharingId"
  },
  {
    title: "AWS Academy Graduate - AWS Academy Cloud Foundations",
    date: "March 2024 - No Expiration",
    id: "de038709-d600-4cb2-91ff-0162c9f98b68",
    link: "https://www.credly.com/badges/de038709-d600-4cb2-91ff-0162c9f98b68/linked_in_profile"
  },
  {
    title: "HackMol 4.0",
    date: "Developer Student Club - NIT J, January 2023",
    id: "f284425a-c375-4439-88db-c26f9a92c0fe",
    link: "https://certificate.givemycertificate.com/c/f284425a-c375-4439-88db-c26f9a92c0fe"
  },
  {
    title: "Machine Learning A-Z™: Hands-On Python & R In Data Science",
    date: "September 2022 - September 2034",
    id: "UC-df034de3-8ed8-456b-b0d7-8a56dabfb39b",
    link: "https://ude.my/UC-df034de3-8ed8-456b-b0d7-8a56dabfb39b"
  },
  {
    title: "Introduction to Artificial Intelligence (AI)",
    date: "August 2021 - August 2034",
    id: "6f74bd9186caf8cb74b613a866366e20",
    link: "https://coursera.org/share/6f74bd9186caf8cb74b613a866366e20"
  }
]

export const achievements = [
  {
    title: "300+ LeetCode Problems Solved",
    description: "Consistent DSA practice across Easy, Medium, and Hard",
    icon: Trophy
  },
  {
    title: "Promoted in 6 Months",
    description: "Fast-track promotion at Cognizant for delivery impact",
    icon: Star
  },
  {
    title: "99.9% Production Uptime",
    description: "GCP/Kubernetes deployments at Implere Tech and Discovr.ai",
    icon: Award
  },
  {
    title: "Open Source Contributor",
    description: "Active on GitHub — job automation, scrapers, and side projects",
    icon: Star
  }
]
